export class SavedBeneficiariesAddress{
  id:number;
  beneficiary:string;
  street:string;
  zip:string;
  town:string;
  country: string;
}
